export const areGroupedOptions = (options) => {
    return (Boolean(options.length) &&
        Array.isArray(options[0]?.options));
};
